<RepairDetailSearch headertext="Water Process  Repair / Event / PM" detailsType="Water Process" AddUrl="/WaterProcess/Repairs/RepairDetail">
